<script setup>
import { useChecklist } from '@/composables/useChecklist'

definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'Checklist',
  },
})

const { templates, recap, loading, fetchTemplates, fetchRecap } = useChecklist()

const templateId = ref(null)
const from = ref(new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10))
const to = ref(new Date().toISOString().slice(0, 10))

onMounted(fetchTemplates)

const templateOptions = computed(() => templates.value.map(t => ({ title: t.name, value: t.id })))

const load = () => {
  if (templateId.value) fetchRecap(templateId.value, { from: from.value, to: to.value })
}

watch(templateId, load)

const headers = [
  { title: 'Unit', key: 'unit_name' },
  { title: 'Jumlah Hasil', key: 'total_results' },
  { title: 'Kepatuhan (Ya/Tidak)', key: 'compliance_rate' },
  { title: 'Rata-rata Skor', key: 'average_score' },
]
</script>

<template>
  <div>
    <VRow class="mb-4">
      <VCol cols="12">
        <h4 class="text-h4 font-weight-bold">
          Rekap Checklist
        </h4>
        <p class="text-body-2 text-medium-emphasis mb-0">
          Rekap kepatuhan/skor per unit dalam suatu periode (AC Module 12)
        </p>
      </VCol>
    </VRow>

    <VCard class="mb-4">
      <VCardText>
        <VRow>
          <VCol
            cols="12"
            md="4"
          >
            <VSelect
              v-model="templateId"
              :items="templateOptions"
              label="Template Checklist"
              density="compact"
            />
          </VCol>
          <VCol
            cols="6"
            md="3"
          >
            <VTextField
              v-model="from"
              type="date"
              label="Dari"
              density="compact"
            />
          </VCol>
          <VCol
            cols="6"
            md="3"
          >
            <VTextField
              v-model="to"
              type="date"
              label="Sampai"
              density="compact"
            />
          </VCol>
          <VCol
            cols="12"
            md="2"
            class="d-flex align-center"
          >
            <VBtn
              block
              :loading="loading"
              :disabled="!templateId"
              @click="load"
            >
              Terapkan
            </VBtn>
          </VCol>
        </VRow>
      </VCardText>
    </VCard>

    <VCard v-if="recap">
      <VCardText>
        <p class="text-body-2 text-medium-emphasis mb-0">
          Periode {{ recap.period.from }} — {{ recap.period.to }} · Total hasil: {{ recap.total_results }}
        </p>
      </VCardText>
      <VDataTable
        :headers="headers"
        :items="recap.by_unit"
        hide-default-footer
        :items-per-page="-1"
      >
        <template #item.unit_name="{ item }">
          {{ item.unit_name ?? 'Tanpa unit' }}
        </template>
        <template #item.compliance_rate="{ item }">
          {{ item.compliance_rate !== null ? `${item.compliance_rate}%` : '-' }}
        </template>
        <template #item.average_score="{ item }">
          {{ item.average_score ?? '-' }}
        </template>
        <template #no-data>
          <div class="text-center py-10">
            <p class="text-medium-emphasis">
              Tidak ada hasil pada periode ini.
            </p>
          </div>
        </template>
      </VDataTable>
    </VCard>
  </div>
</template>
